<template>
  <div>
    <Row style="background:#eee;padding:20px" v-for="(item, index) in question" :key="index">
      <i-col span="22" style="width: 100%;">
        <Card :bordered="false">
          <Card dis-hover>
            <p slot="title" v-html="item.describe" style="height: auto;font-weight: normal;"></p>
            <div class="img" :style="{ width: isPhone ? '100%' : '30%' }">
              <img :src="item.imageUrl" style="" v-if="item.imageUrl" @click="viewImg" />
            </div>
            <div v-if="item.tableValue" v-html="item.tableValue">

            </div>
            <ul>
              <li ref="list" v-for="(item1, index1) in item.trunkList" :key="index1" :id="'element' + item1.serial"
                class="question-item" style="display: flex;"
                :style="{ flexDirection: item1.content.includes('[blank]') ? 'row' : 'column', alignItems: item1.content.includes('[blank]') ? 'center' : '' }">
                <p v-html="contentFilters(item1.content)" style="padding: 10px 0">
                </p>
                <!--<Input />-->
                <Input focus v-if="item1.content.includes('[blank]')" v-model="value[item1.serial - 1]"
                  :placeholder="item1.serial" style="width: 180px;margin-left: 30px;display: flex;align-items: center;"
                  @on-blur="inputBlue(index1, item1.serial)" />
                <!--<Input focus v-if="item1.content.includes('[blank]')" v-model="valueCom(item1.serial)" :placeholder="item1.serial" style="width: 180px;margin-left: 30px;display: flex;align-items: center;" @on-blur="inputBlue(item1.serial)" />-->
                <p style="padding-left: 20px;color:#333" v-if="isShowAnswer"
                  :style="colorCom(item1.answer, value[item1.serial - 1], checkboxItem[item1.id])">
                  {{ answerCom(item1.answer) }}</p>
                <ul v-if="item.matchType === 3">
                  <li class="question-item select" style="background: #eee">
                    <RadioGroup vertical v-model="value[item1.serial - 1]"
                      @on-change="change(index1, value[item1.serial - 1])">
                      <Radio :label="0"><span>TRUE</span></Radio>
                      <Radio :label="1"><span>FALSE</span></Radio>
                      <Radio :label="2"><span>NOT GIVEN</span></Radio>
                    </RadioGroup>
                  </li>
                </ul>
                <ul v-if="item1.option && item1.answer.length === 1">
                  <li class="question-item select" style="background: #eee">
                    <RadioGroup vertical v-model="value[item1.serial - 1]"
                      @on-change="change(index1, value[item1.serial - 1])">
                      <Radio v-for="(item3, index3) in item1.option" :key="index3" :label="index3">
                        <span v-html="item3"></span>
                      </Radio>
                    </RadioGroup>
                  </li>
                </ul>
                <ul v-if="item1.option && item1.answer.length > 1">
                  <li class="question-item select" style="background: #eee">
                    <CheckboxGroup @on-change="checkboxChange" class="checkbox" v-model="checkboxItem[item1.id]">
                      <span @click="showLength(item1.serial, item1.id)" style="display: flex;flex-direction: column;">
                        <Checkbox v-for="(item3, index3) in item1.option" :key="index3" :label="index3"
                          :disabled="checkboxItem[item1.id] !== undefined && isLen[item1.id] && !checkboxItem[item1.id].includes(index3)">
                          <span v-html="item3" style="padding-left: 5px"></span>
                        </Checkbox>
                      </span>
                    </CheckboxGroup>
                  </li>
                </ul>
              </li>
            </ul>
            <ul>
              <li v-for="(item2, index2) in item.matchValue" :key="index2" class="question-item"
                style="background: #eee">
                <p>{{ item2 }}</p>
              </li>
            </ul>
          </Card>
          <p slot="title" v-html="item.theme"></p>
        </Card>
      </i-col>

    </Row>
  </div>
</template>

<script>
export default {
  name: "hearing",
  directives: {
    focus: {
      inserted: function (el, { value }) {
        if (value) {
          el.focus();
        }
      },
    },
  },
  data() {
    return {
      isShowAnswer: false,
    };
  },
  methods: {
    viewImg(event) {
      const imgNode = event.currentTarget;
      if (!imgNode.viewer) {
        $(imgNode).viewer();
        imgNode.click();
      } else {
        $(imgNode).viewer();
      }
    },
    // checkboxChange(){},
    change(e) {
      console.log(e);
      // console.log(321);
    },
    // change(e){
    //   console.log(e);
    // },
    seeAnswer() {
      this.isShowAnswer = !this.isShowAnswer;
    },
  },
  computed: {
    colorCom() {
      return function (l, r, id) {
        let arr = [];
        l.forEach((item) => {
          arr += ` ${item}`;
        });
        //输入的内容 r
        //正确答案 l
        // console.log(l);
        if (Number.isFinite(r)) {
          switch (r) {
            case 0:
              r = "A";
              break;
            case 1:
              r = "B";
              break;
            case 2:
              r = "C";
              break;
            case 3:
              r = "D";
              break;
          }
          if (arr.trim() === r.trim()) {
            return {
              color: "#60b534",
            };
          } else {
            return {
              color: "#f00",
            };
          }
        } else if (l.length > 1) {
          let arrs = [];
          if (id) {
            id.forEach((item) => {
              switch (item) {
                case 0:
                  arrs.push("A");
                  break;
                case 1:
                  arrs.push("B");
                  break;
                case 2:
                  arrs.push("C");
                  break;
                case 3:
                  arrs.push("D");
                  break;
                case 4:
                  arrs.push("E");
                  break;
                case 5:
                  arrs.push("F");
                  break;
                case 6:
                  arrs.push("G");
                  break;
                case 7:
                  arrs.push("H");
                  break;
              }
            });
          }
          // arrs = JSON.parse(JSON.stringify(arrs)
          console.log(l.toString());
          console.log(arrs.toString());
          if (l.toString() === arrs.toString()) {
            return {
              color: "#60b534",
            };
          } else {
            return {
              color: "#f00",
            };
          }
        } else {
          let newL = arr.toLowerCase().trim();
          if (r) {
            let newR = r.toLowerCase().trim();
            if (newL === newR) {
              return {
                color: "#60b534",
              };
            } else {
              return {
                color: "#f00",
              };
            }
          }
        }
      };
    },
    answerCom() {
      return function (list) {
        let arr = [];
        list.forEach((item) => {
          arr += ` ${item}`;
        });
        return `正确答案：${arr}`;
      };
    },
  },
  props: {
    answer: Object,
    data: Array,
    question: Array,
    contentFilters: Function,
    page: Number,
    isPhone: Boolean,
    value: Array,
    inputBlue: Function,
    checkboxChange: Function,
    checkboxItem: Array,
    isLen: Array,
    showLength: Function,
    selectItemIndex: Number,
  },
};
</script>

<style scoped lang="stylus">
.ivu-card-head p {
  overflow: visible !important;
  white-space: normal !important;
}

.question-item {
  padding: 10px 10px;
}

.checkbox {
  display: flex;
  flex-direction: column;

  .ivu-checkbox-wrapper {
    padding: 10px 0;
  }
}

.ivu-row:last-child {
  margin-bottom:64px;
}

@media screen and (max-width: 1920px) {
    .ivu-row:last-child {
  margin-bottom:104px;
}
}
@media screen and (max-width: 960px) {
    .ivu-row:last-child {
  margin-bottom:136px;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/Exercise/children/Hearing.vue